import axios from "axios";

export const DeleteNews = async (appNewsId) => {
  const token = JSON.parse(localStorage.getItem("authentication"));
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params: { appNewsId },
  };

  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_BACKEND_API}/api/news/DeleteNews`,
      config
    );
    return { status: 200, payload: data };
  } catch (error) {
    console.error("DeleteNews error:", error);
    const status = error?.response?.status || 500;
    return { status, payload: null };
  }
};
